import { TableCard } from 'app/components'
import { FornecedoresListHeader } from './components/header/FornecedoresListHeader'
import { ListFiltersProvider } from './core/ListFiltersProvider'
import { QueryRequestProvider } from './core/QueryRequestProvider'
import { QueryResponseProvider } from './core/QueryResponseProvider'
import { FornecedoresTable } from './table/FornecedoresTable'

const FornecedoresList = () => (
  <TableCard>
    <FornecedoresListHeader />
    <FornecedoresTable />
  </TableCard>
)

export const FornecedoresListWrapper = () => (
  <QueryRequestProvider>
    <QueryResponseProvider>
      <ListFiltersProvider>
        <FornecedoresList />
      </ListFiltersProvider>
    </QueryResponseProvider>
  </QueryRequestProvider>
)
